<template>
	<section class="content">
		<div class="card">
			<div class="card-body">
				<table class="table table-hover mw-100" ref="tablecache">
					<thead>
						<tr>
							<th>Key</th>
							<th>Value</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody @click="handleClick"></tbody>
				</table>
			</div>
		</div>
	</section>
</template>

<script>
import { createTable, authFetch } from "@/libs/hxcore";
import $ from "jquery";

export default {
	name: "Data Cache",
	data() {
		return {
			method: '',
			form: {
				key: '',
				value: '',
			},
			loading: false,
		};
	},
	methods: {
		handleClick(e) {
			if (e.target.matches(".delete-cache")) {	
				this.loading = true;
				authFetch("/publik/cache", {
					method: "POST",
					headers: {
							Accept: "application/json",
							"Content-Type": "application/json",
						},
					body: JSON.stringify({"key" : e.target.value}),
				})
				.then((res) => {
					this.table.api().ajax.reload();
					this.loading = false;
				});
			} 
		},
	},
	mounted() {
		const e = this.$refs;
		this.table = createTable(e.tablecache, {
			ajax: "/publik/cache",
			frame: false,
			toolbarEl: e.toolbar,
			processing: true,
			lengthChange: true,
			searching : true,
			scrollCollapse: true,
			autoWidth: false,
			language: {
				processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'},
			columns: [
				{ data: "key" },
				{
					data: "value",
					sortable: false,
					className: 'text-break'
				},
				{
					data: "key",
					sortable: false,
					align: "center",
					render: function (data, type, row, meta) {
						return `<button class="btn btn-danger delete-cache" value="${data}">Delete</button>`;
					}
				},
			],
			serverSide: false,
			filterBy: [ 0],
			initComplete: function () {
				$('.loading-overlay').removeClass('show');
			},
		});
	},
};
</script>